document.addEventListener("DOMContentLoaded", function () {
  const heroSection = document.querySelector(".index-section--hero");
  if (!heroSection) return;

  const heroImages = heroSection.querySelectorAll("img.hero__image");
  heroImages.forEach(img => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";

    if (img.srcset) {
      link.setAttribute("imagesrcset", img.srcset);
    }
    if (img.sizes) {
      link.setAttribute("imagesizes", img.sizes);
    }

    link.href = img.currentSrc || img.src;
    link.setAttribute("fetchpriority", "high");
    document.head.appendChild(link);
  });
});